import React, { useEffect, useState } from 'react';
import styles from '../AddEntity.module.scss';
import './AddSubstantialChangeType.scss';
import ContentManagerTable from '../../ContentManagerTable/ContentManagerTable';
import { dataTypes, tableRowTypeKeys } from '../../ContentManagerKeys';
import { makeStyles, Tab, Tabs } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { contentManagerTabStyles } from '../../../Projects/ProjectsAll/ProjectsAll.Style';
import ContentManagerLoader from '../../ContentManagerLoader/ContentManagerLoader';
import { loaderCustomStyles } from '../../../Util/ContentManager/ContentManager';
import { AddSubstantialChangeTypeModal } from './Modal/AddSubstantialChangeTypeModal';
import { SubstantialChangesType } from './SubstantialChangesConstants';
import { mapSubstantialChangeTypeToRequestBody } from './Utils/SubstantialChangesUtils';
import { createSubstantialAndFundamentalChange, updateSubstantialAndFundamentalChange } from '../../../../api/contentManager';

type AddSubstantialChangeTypeProps = {
  apiCall: any;
  languageId: number;
}

export const AddSubstantialChangeType = ({ apiCall, languageId }: AddSubstantialChangeTypeProps) => {
  const classes = makeStyles(contentManagerTabStyles)();
  const tabClasses = { root: classes.root, selected: classes.selected };
  const { t } = useTranslation();

  const [dataTableList, setDataTableList] = useState({
    collection: [],
    totalItems: 0,
    itemsPerPage: 5,
    pageNumber: 1,
  });
  const [tabValue, setTabValue] = useState<SubstantialChangesType>(SubstantialChangesType.NonSovereingn);
  const [loading, setLoading] = useState<boolean>(false);
  const [isOpenCreateModal, setIsOpenCreateModal] = useState<boolean>(false);

  useEffect(() => {
    getSubstantialChangeTypes();
  }, []);

  useEffect(() => {
    getSubstantialChangeTypes();
  }, [tabValue])


  const getSubstantialChangeTypes = async () => {
    setLoading(true);
    try {
      const response = await apiCall();
      setDataTableList({
        ...dataTableList,
        collection: response &&
          response
            .filter(item => item.sovereignOperationsId === tabValue)
            .map(item => ({
              id: item.id,
              translations: item.translation,
              languageId: item.translation[0].languageId,
              languageName: item.translation[0].name,
              text: item.name,
              operationType: item.sovereignOperationsId,
              active: item.isActive,
              type: dataTypes.substantialAndFundamentalChange
            })) || [],
        totalItems: response ? response.length : 0,
      });
    } catch (error) {
      console.error('error', error)
    } finally {
      setLoading(false);
    }
  }

  const createItem = (item: any) => {
    const payload = mapSubstantialChangeTypeToRequestBody(item);
    createSubstantialAndFundamentalChange(payload)
    .then(() => getSubstantialChangeTypes())
    .catch(error => console.error('error', error));
  };

  const updateItem = (item: any) => {
    const payload = mapSubstantialChangeTypeToRequestBody(item);
    updateSubstantialAndFundamentalChange(payload)
    .then(() => getSubstantialChangeTypes())
    .catch(error => console.error('error', error));
  };

  const activeItem = (item: any) => {
   const activatedItem = {
      ...item,
      isActive: !item.active
    }

    updateItem(activatedItem);
  };

  return (
    <>
      <section className='substantial-types-header'>
        <Tabs
          value={tabValue}
          classes={{
            indicator: classes.indicatorColor,
            root: classes.root,
          }}
          aria-label="full width tabs"
          className='tabs-contents'
        >
          <Tab
            value={SubstantialChangesType.NonSovereingn}
            label={t('not_sovereign_guarantee_operation')}
            onClick={() => setTabValue(SubstantialChangesType.NonSovereingn)}
            classes={tabClasses}
          />
          <Tab
            value={SubstantialChangesType.Sovereingn}
            label={t('sovereign_guarantee_operation')}
            onClick={() => setTabValue(SubstantialChangesType.Sovereingn)}
            classes={tabClasses}
          />
        </Tabs>
        <div className='substantial-types-header-add-button'>
          <button
            className='btn btn-primary btn-primary-manager'
            onClick={() => setIsOpenCreateModal(true)}
          >
            {t('add')}
          </button>
        </div>
      </section>
      <section className='substantial-types-content'>
        {
          loading ? (
            <ContentManagerLoader styles={loaderCustomStyles} />
          )
            : (
              <div className={styles.row + ' substantial-types-table'}>
                <ContentManagerTable
                  type={tableRowTypeKeys.editAndActive}
                  items={dataTableList.collection}
                  dataInfo={dataTableList}
                  resetStyle={{ marginLeft: 0, width: '100%' }}
                  updateItem={updateItem}
                  activeItem={activeItem}
                  displayGenericErrorMessage={error => console.log(error)}
                />
              </div>
            )
        }
      </section>
      <AddSubstantialChangeTypeModal
        isOpen={isOpenCreateModal}
        operationType={tabValue}
        onSubmit={(item) => {createItem(item)}}
        cancel={() => { }}
        closeModal={() => setIsOpenCreateModal(false)}
        disableDraftSubmit={false}
        submitting={false}
      />
    </>
  )
}
